/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { CanDeactivateViaEditGuardService } from './can-deactivate-via-edit-guard.service';
import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';

/**
 * @export
 * @class RouteChangePopupService
 */
@Injectable()
export class RouteChangePopupService {

  private routeChangeBS: Subject<Object>;
  routeChange: Observable<Object>;

  /**
   * Creates an instance of RouteChangePopupService.
   * @param {Router} router
   * @param {CanDeactivateViaEditGuardService} canDeactivateViaEditGuardService
   *
   * @memberOf RouteChangePopupService
   */
  constructor(private router: Router, private canDeactivateViaEditGuardService: CanDeactivateViaEditGuardService) {
    const editmode = false;
    this.routeChangeBS = new Subject();
    this.routeChangeBS.next(editmode);
    this.routeChange = this.routeChangeBS.asObservable();
  }

  /**
   * @param {Object} loaderStatus
   *
   * @memberOf RouteChangePopupService
   */
  updateRouteMode(loaderStatus: Object) {
    this.setStoredLocationPath();
    this.routeChangeBS.next(loaderStatus);
  }

  /**
   * @memberOf RouteChangePopupService
   */
  goToNextRoute() {
    this.setStoredLocationPath();
    this.router.navigateByUrl(this.canDeactivateViaEditGuardService.nextUrl, { skipLocationChange: environment.hideUrl });
  }

  setStoredLocationPath() {
    const savedLocation = localStorage.getItem('lms_app_location')
    if (savedLocation) {
      window.history.pushState('html', document.title, savedLocation);
    } else {
      window.history.pushState('html', document.title, window.location.origin);
    }
  }
}
